import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previews } from '../data/previews';
export function PagePreviews() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const updateEdges = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 8);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 8);
  }, []);
  useEffect(() => {
    updateEdges();
    window.addEventListener('resize', updateEdges);
    return () => window.removeEventListener('resize', updateEdges);
  }, [updateEdges]);
  const scrollByCard = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('li');
    const amount = card ? card.clientWidth + 20 : el.clientWidth * 0.8;
    el.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  };
  return <section aria-label="Anteprima delle pagine interne" className="bg-transparent" data-id="element-117" data-mp="343ujsif8f9zh">
      <div className="mx-auto max-w-6xl px-5 pb-12 pt-2" style={{
      paddingBottom: "11px"
    }} data-id="element-118" data-mp="392nts0vb8iuw">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-119" data-mp="3e0fp74v5yn3u">
          <div data-id="element-120" data-mp="3ir5smck14fvw">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-121" data-mp="3irnvhs175scs">
              👀 Sbircia dentro
            </p>
            <h2 className="mt-2 font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-122" data-mp="3mshhugyzqz3k">
              Alcune pagine reali del metodo
            </h2>
            <p className="mt-2 max-w-xl text-sm text-plum/60" data-id="element-123" data-mp="m2l6l6lbrsb">
              Schede visive, tabelle di pronuncia e frasi pronte all'uso: questo è l'aspetto vero
              dei tomi e dei bonus.
            </p>
          </div>

          <div className="hidden gap-2 sm:flex" data-id="element-124" data-mp="22e7f227ngz5o">
            <button type="button" onClick={() => scrollByCard(-1)} disabled={atStart} aria-label="Pagina precedente" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35 focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-125" data-mp="22fii1zt9u2vq">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-126" data-mp="297e6q1ip3i1r" />
            </button>
            <button type="button" onClick={() => scrollByCard(1)} disabled={atEnd} aria-label="Pagina successiva" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35 focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-127" data-mp="2492yfv81tfln">
              <ChevronRightIcon className="h-5 w-5" data-id="element-128" data-mp="2n1nlux4zasi2" />
            </button>
          </div>
        </div>

        <ul ref={trackRef} onScroll={updateEdges} tabIndex={0} className="mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 [scrollbar-width:thin] focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-129" data-mp="311g5k8i388gj">
          {previews.map((p, i) => <li key={p.id} className="w-[240px] shrink-0 snap-start sm:w-[280px]" data-id="element-130" data-mp="3kmge4iut8s43" data-mpi={i}>
              <div className="aspect-[4/5] w-full overflow-hidden rounded-2xl border border-grape/15 bg-lilac-soft shadow-[0_16px_40px_-28px_rgba(46,16,101,0.55)]" data-id="element-131" data-mp="36mxk0tyu3has">
                <img src={p.src} alt={p.caption} width={1080} height={1350} loading={i < 2 ? 'eager' : 'lazy'} decoding="async" sizes="(min-width: 640px) 280px, 240px" className="h-full w-full object-cover object-top" data-id="element-132" data-mp="3bkgxhrnpjq1o" />
              </div>
            </li>)}
        </ul>

        <p className="mt-1 text-center text-xs font-medium text-plum/45 sm:hidden" data-id="element-133" data-mp="2nx8ujgdr4t2t">
          ← Scorri per vedere tutte le pagine →
        </p>
      </div>
    </section>;
}